export default __webpack_public_path__ + "static/observian-cloud-angled-935fee978d619685aca724795e1a7c13.png";